import { Signal0 } from "@/js/util/event/Signal0";
import { Value } from "@/js/util/Value";
import Disposable from "@/game/libs/engine/util/disposable";

export interface Controller extends Disposable {
  onJump: Signal0;
  onFace: Value<PlayerDirection>;
  reset: () => void;
}

export enum PlayerDirection {
  FACE_UP = 0,
  FACE_LEFT = 1,
  FACE_SLIGHT_LEFT = 2,
  FACE_DOWN = 3,
  FACE_SLIGHT_RIGHT = 4,
  FACE_RIGHT = 5
}
